const initPdfSelector = '.create-pdf';
const initSinglePdfSelector = `${initPdfSelector}[data-pdf-pages="single"]`;
const initMultiPdfSelector = `${initPdfSelector}[data-pdf-pages="multi"]`;
const activeTabSelector = '.nav-tabs > li.active > a';
const activePageSelector = '.main-toc li.active > p > a';
const checkedPdfBoxLinkSelector = '.main-toc input:checked~a';
const checkedPdfBoxSelector = '.main-toc input:checked';

const pdfBtn = '.pdf-btn';
const siteLoader = document.querySelector('.site-loader-modal');
let siteLoaderTimeout;

const pdfDownloadLink = document.querySelector('#pdf-download-link');
const pdfDismissBtn = document.querySelector('.pdf-dismiss');
const pdfDoneBtn = document.querySelector('.pdf-done');
const pdfModel = document.querySelector('.pdf-modal');
let pdfstyles = null;
let userSubmittedEmail = false;
const pdfEmailForm = document.querySelector('.pdf-email-form');
const pdfEmailInput = document.querySelector('#pdf_email');
const pdfIdInput = document.querySelector('#pdf_id');
const oemSlug = document.querySelector("meta[name='cv-oem-slug']");



function postUrlList(urls=null){
    let urlList = urls;
    if (urls === null){
        console.log('getting list of urls');
        urlList = {'URL': []};
        document.querySelectorAll(checkedPdfBoxLinkSelector).forEach( link => {
            urlList['URL'].push(link.href);
        });
    }
    fetch('/api/pdf/id', {
        'method': 'POST',
        'headers': {'content-type': 'application/json'},
        'cache': 'no-cache',
        'body': JSON.stringify(urlList)
    })
    .then(function(response){
        return response.json();
    })
    .then(function(data){
        if (data.success){
            pdfIdInput.value = data['id'];
            if (urls === null){
                siteLoader.classList.remove('show');
                pdfModel.classList.add('show');
            }
            fetch('/api/pdf/create', {
                    'method': 'POST',
                    'headers': {'content-type': 'application/json'},
                    'cache': 'no-cache',
                    'body': JSON.stringify(data)
                })
                .then(function(response){
                    return response.json();
                })
                .then(function(data) {
                    if (data.success) {
                    //    hide the pdfform and show the download link
                        if (!userSubmittedEmail) {
                            pdfDownloadLink.setAttribute('href', data['link']);
                            pdfDownloadLink.click();
                        }
                        pdfIdInput.value = '';
                    }
                })
                .then( ()=>{
                    siteLoader.classList.remove('show');
                    pdfModel.classList.remove('show');
                    resetPdfCheckboxes();
                    userSubmittedEmail = false;
                });
        }
    });
}

function resetPdfCheckboxes(){
    try{
        document.querySelectorAll(checkedPdfBoxSelector).forEach( box => {
            box.checked = false;
        });
        if (!!pdfstyles) {
            pdfstyles.remove();
            pdfstyles = null;
        }
    } catch (err){
        console.log(err);
    }
}

function togglePdfCheckboxes(){
    if (pdfstyles === null){
        pdfstyles = document.createElement('style');
        pdfstyles.innerHTML = `.pdf-checkbox{display:block;}.nav-link-wrapper{margin-left:0;}`;
        document.head.append(pdfstyles);
    } else {
        resetPdfCheckboxes();
    }
}

function initPdfModal(){
    pdfDismissBtn.addEventListener('click', e => {
        resetPdfCheckboxes();
    });
    pdfDoneBtn.addEventListener('click', e => {
        siteLoader.classList.add('show');
        postUrlList();
    });
}

function initPdfDropdown(){

    document.querySelectorAll(pdfBtn).forEach(pdfBtn => {

        const singlePdfTrigger = pdfBtn.querySelector(initSinglePdfSelector);
        const multiPdfTrigger = pdfBtn.querySelector(initMultiPdfSelector);

        function singlePdfClickHandler(e){
            const singlePdfTrigger = e.target.closest(initSinglePdfSelector);
            const activePage = document.querySelector(activePageSelector);
            if (singlePdfTrigger){
                e.preventDefault();
                siteLoader.classList.add('show');
                postUrlList({'URL': [activePage.href]});
            }
        }

        function multiPdfClickHandler(e){
            const multiPdfTrigger = e.target.closest(initMultiPdfSelector);
            const activePage = document.querySelector(activePageSelector);
            if (multiPdfTrigger){
                e.preventDefault();
                let activeCheckbox = activePage.previousElementSibling;
                activeCheckbox.checked = true;
                togglePdfCheckboxes();
            }
        }

        pdfBtn.addEventListener('click', e => {
            singlePdfClickHandler(e);
            multiPdfClickHandler(e);
        });

    });
}

function initPdfEmailForm(){
    pdfEmailForm.addEventListener('submit', e => {
        e.preventDefault();
        userSubmittedEmail = true;
        console.log('triggered pdf email');
        let emailData = {'email': pdfEmailInput.value, 'id': pdfIdInput.value};
        console.log(JSON.stringify(emailData));
        fetch('/api/pdf/email', {
            'method': 'POST',
            'headers': {'content-type': 'application/json'},
            'cache': 'no-cache',
            'body': JSON.stringify(emailData)
        })
        .then(function (response) {
            return response.json();
        })
        .then(function (data) {
            if (data.success) {
                siteLoader.classList.remove('show');
                pdfModel.classList.remove('show');
                resetPdfCheckboxes();
            }
        });
    });
}

function initPdf() {
    try{
        initPdfModal();
        initPdfDropdown();
        initPdfEmailForm();
    } catch (err) {
        console.log(`could not init the pdf controls: ${err}`);
    }

}

export default initPdf;